export default __webpack_public_path__ + "static/media/giphy.787aa965.svg";